var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$store.getters.isAuthenticated)?_c('main-header'):_vm._e(),_c('router-view'),_c('notificator'),(_vm.$store.getters.isAuthenticated && !_vm.$store.state.hideFooter)?_c('main-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }